import { render, staticRenderFns } from "./ExternalAuthPage.vue?vue&type=template&id=51885ab6&scoped=true"
import script from "./ExternalAuthPage.vue?vue&type=script&lang=js"
export * from "./ExternalAuthPage.vue?vue&type=script&lang=js"
import style0 from "./ExternalAuthPage.vue?vue&type=style&index=0&id=51885ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51885ab6",
  null
  
)

export default component.exports